export const INDUCT_MANAGEMENT_FIELDS = ["assignedNode", "forceInductStatus", "activeUntilMillis"]

export const FORCE_INDUCT_FIELDS = ["status","updatedBy"]

export const IS_USER_PERMITTED = "isUserPermitted";
export const ACCOUNT_ID = {
    JP_AMZL_ROOT: "AJGZQ6KPMOFMJ",
    AMZN_UK: "A1RFMHSF0CZ9W2",
    US_ROOT: "A1OGQG95VEURM9"
}
export const REGION = {
    US: "US",
    FE: "FE",
    EU: "EU"
}

export const FORCE_STATUS = {
    AUTOMATED: "AUTOMATED",
    ENABLED: "ENABLED",
    DISABLED: "DISABLED",
}

export const SORTATION_TYPE = {
    SORT_TO_ZONE: "SORT_TO_ZONE",
    SORT_TO_ROUTE: "SORT_TO_ROUTE",
    SORT_TO_CART: "SORT_TO_CART"
}

export const CONTAINER_TYPE = {
    PALLET: "PALLET",
    CART: "CART"
}

export const CONTAINER_TYPE_DISPLAY_LABELS = {
    PALLET: "Pallet/Shuttle",
    CART: "Cart"
}

export const CUBE_TYPE = {
    SMALL: "SMALL",
    MEDIUM: "MEDIUM",
    LARGE: "LARGE",
    NON_CONVEYABLE: "NON_CONVEYABLE"
}

export const CUBE_TYPE_DISPLAY_LABELS = {
    SMALL: "Small",
    MEDIUM: "Medium",
    LARGE: "Large/Extra Large",
    NON_CONVEYABLE: "Non_Conveyable/Heavy_Bulky"
}

export const BELT_STATUS = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE"
}

export const SETTINGS_TYPE = "INBOUND_SETTINGS";

export const SORT_PATH_SETTING_STATUS = {
    PENDING_UPDATE: "PENDING_UPDATE",
    UPDATED: "UPDATED"
};

export const DELIMITER = "-";

export const RESOURCE_TYPE = {
    INDUCT_AREA: "INDUCT_AREA",
    INBOUND_LANE: "INBOUND_LANE",
    DOCK_DOOR: "DOCK_DOOR"
};

export const DWC_ACTIONS = {
    LOAD_VIEW: "LOAD_VIEW",
    SAVE_CONFIG: "SAVE_CONFIG",
    ADD_CYCLE: "ADD_CYCLE",
    REMOVE_CYCLE: "REMOVE_CYCLE",
    ADD_WINDOW: "ADD_WINDOW",
    REMOVE_WINDOW: "REMOVE_WINDOW",
    RECEIVE_DATA: "RECEIVE_DATA",
    SET_VALUE: "SET_VALUE",
    SET_ALERT: "SET_ALERT",
    CLEAR_ALERT: "CLEAR_ALERT",
    EDIT_ACCESS: "EDIT_ACCESS"
}

export const AMAZON_SUFFIX = "@amazon.com";
export const DEFAULT_HOUR = 4

export const HOUR_OPTIONS = {
    "1 hour" : 1,
    "2 hours" : 2,
    "3 hours" : 3,
    "4 hours" : 4,
    "5 hours" : 5,
    "6 hours" : 6,
    "7 hours" : 7,
    "8 hours" : 8,
    "9 hours" : 9,
    "10 hours" : 10,
    "11 hours" : 11,
    "12 hours" : 12,
}

export const DEFAULT_ALERT = {id: "", default:"", values: {}, type: "error"}

export const DEFAULT_TIME_WINDOW = {startTimeString: "", endTimeString: ""}

export const EMPTY_STRING_PLACEHOLDER = "-"

export const CORE_CYCLE_PREFIX = "CYCLE_"

export const NONNULL_PLANNED_CYCLE_FIELD = ["cycleID", "cycleName", "sortationType"]

export const CYCLE_TYPE = ["DYNAMIC", "SORT_TO_ROUTE"]

export const DELIVERY_WINDOW_CONFIG_ALERTS = {
    GET_CONFIG_FAIL: {
        id: "inductmanagement.getConfigFail",
        default: "Encountered an error while trying to retrieve package cycle configuration",
        values: {},
        type: "error"
    },
    SET_CONFIG_FAIL: {
        id: "inductmanagement.setConfigFail",
        default: "Encountered an error while trying to set package cycle configuration",
        values: {},
        type: "error"
    },
    NO_WINDOWS: {
        id: "inductmanagement.noWindowsConfigured",
        default: "No scheduled delivery windows configured. Press edit to add new windows",
        values: {},
        type: "informational"
    },
    NO_CYCLES: {
        id: "inductmanagement.noCyclesPresent",
        default: "No cycles have been configured for this station. Please set up cycles before proceeding to delivery window configuration.",
        values: {},
        type: "warning"
    },
    NOT_ENABLED: {
        id: "inductmanagement.notEnabled",
        default: "Scheduled delivery window configuration tab has not been enabled for your station",
        values: {},
        type: "informational"
    },
    SAVE_SUCCESS: {
        id: "inductmanagement.saveSuccess",
        default: "Configuration change sent successfully. Changes may take up to 60 minutes to be applicable for incoming scheduled delivery packages",
        values: {},
        type: "success"
    }
}

export const FORCE_INDUCT_ALERTS = {
    NOT_ENABLED: {
        id: "inductmanagement.parallelNotEnabled",
        default: "Parallel induct tab has not been enabled for your station",
        values: {},
        type: "informational"
    }
}

export const INDUCT_CONFIG_ALERTS = {
    SAVE_SUCCESS: {id: "inductconfig.saveSuccess", default: "Configuration saved successfully", values: {}, type: "success"},
    SAVE_ERROR: {id: "inductconfig.saveError", default: "Failed to save configuration", values: {}, type: "error"},
    UPLOAD_SUCCESS: {id: "inductconfig.uploadSuccess", default: "CSV uploaded successfully! Configuration fields have been updated.", values: {}, type: "success"},
    UPLOAD_ERROR: {id: "inductconfig.uploadError", default: "Failed to upload configuration.", values: {}, type: "error"},
    STATION_MISMATCH: {id: "inductconfig.validationError", default: "Validation failed: Station code in CSV does not match the selected station.", values: {}, type: "error"},
    CYCLE_MISMATCH: {id: "inductconfig.cycleMismatchError", default: "Validation failed: Cycle in CSV does not match the selected cycle.", values: {}, type: "error"},
    BELT_NAME_REQUIRED: {id: "inductconfig.beltNameRequired", default: "Please select a belt name for all added belts before saving.", values: {}, type: "error"},
    REFRESH_SUCCESS: {id: "inductconfig.refreshSuccess", default: "Configuration refreshed successfully", values: {}, type: "success"},
    REFRESH_ERROR: {id: "inductconfig.refreshError", default: "Failed to refresh configuration. Please retry.", values: {}, type: "error"}
}

export const VALIDATION_ERROR_CODES = {
    NO_ACTIVE_LANES: "NO_ACTIVE_LANES",
    NO_CART_LANES: "NO_CART_LANES",
    BELT_NO_CONTAINER_TYPES: "BELT_NO_CONTAINER_TYPES",
    BELT_NO_CUBE_TYPES: "BELT_NO_CUBE_TYPES",
    NO_ACTIVE_BELTS: "NO_ACTIVE_BELTS",
    CONTAINER_TYPE_NOT_COVERED: "CONTAINER_TYPE_NOT_COVERED",
    CUBE_TYPE_NOT_COVERED: "CUBE_TYPE_NOT_COVERED",
    INVALID_LANE_ENTERED: "INVALID_LANE_ENTERED"
}

export const VALIDATION_ERROR_ALERT_MAP = {
    [VALIDATION_ERROR_CODES.NO_ACTIVE_LANES]: {id: "inductconfig.noActiveLanes", default: "All lanes are either inactive or hold lanes, no lanes left for pallet or cart.", type: "error"},
    [VALIDATION_ERROR_CODES.NO_CART_LANES]: {id: "inductconfig.noCartLanes", default: "All lanes are either inactive, hold or pallet lanes. No lanes left for Carts.", type: "error"},
    [VALIDATION_ERROR_CODES.BELT_NO_CONTAINER_TYPES]: {id: "inductconfig.beltNoContainerTypes", default: "One or more belts have no container types selected. Select at least one container type for each belt.", type: "error"},
    [VALIDATION_ERROR_CODES.BELT_NO_CUBE_TYPES]: {id: "inductconfig.beltNoCubeTypes", default: "One or more belts have no cube types selected. Select at least one cube type for each belt.", type: "error"},
    [VALIDATION_ERROR_CODES.NO_ACTIVE_BELTS]: {id: "inductconfig.noActiveBelts", default: "No active induct belts configured. At least one belt must be active to process packages.", type: "error"},
    [VALIDATION_ERROR_CODES.CONTAINER_TYPE_NOT_COVERED]: {id: "inductconfig.containerTypeNotCovered", default: "One or more container types are not assigned to any active belt. All container types must be covered by at least one active belt.", type: "error"},
    [VALIDATION_ERROR_CODES.CUBE_TYPE_NOT_COVERED]: {id: "inductconfig.cubeTypeNotCovered", default: "One or more cube types are not assigned to any active belt. All cube types must be covered by at least one active belt.", type: "error"},
    [VALIDATION_ERROR_CODES.INVALID_LANE_ENTERED]: {id: "inductconfig.invalidLaneEntered", default: "Invalid lane entered. Please enter a valid lane identifier.", type: "error"}
}

export const CSV_HEADERS = "station_code,cycle,active_doors,hold_lanes,inactive_lanes,pallet_lanes";

export const CSV_BELT_HEADERS = "belt_1_name,belt_1_status,belt_1_container_types,belt_1_cube_types,belt_2_name,belt_2_status,belt_2_container_types,belt_2_cube_types,belt_3_name,belt_3_status,belt_3_container_types,belt_3_cube_types";

export const CSV_TEMPLATE_HEADER = CSV_HEADERS + "," + CSV_BELT_HEADERS;

export const CSV_TEMPLATE_SAMPLE = 'DAU1,AD_HOC_1,"DD1, DD2, DD3, DD4, DD5","IB.A25, IB.A26, IB.A27","IB.X1, IB.X2","IB.P1:IB.P5",ASL_1,ACTIVE,PALLET,"SMALL, MEDIUM",GA1,ACTIVE,"PALLET, CART","SMALL, MEDIUM, LARGE",,,,';

export const CANCEL_CONFIRMATION_MESSAGE = "Are you sure you want to cancel? All unsaved changes will be lost.";

export const CSV_TEMPLATE_FILENAME = "induct-configuration-template.csv";



// WEBPACK FOOTER //
// ./src/components/inductmanagementv2/Constants.js